// FIXME(complexity) - Invalid disabling of the complexity lint rule
/* eslint-disable complexity */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { buildFilterKeys } from "@faire/retailer-shared/filters/filterKeys";
import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { ResultsDropdownSectionHeaderWrapper, ResultsDropdownSectionsWrapper, ResultsDropdownView } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Styled";
import { ARROW_DOWN, ARROW_UP, getBrandsHeader, getBrandsYouMightKnowHeader, getRecentlyViewedHeader, getRecentSearchesHeader, getSectionIdMap, getSuggestedTermsHeader, getTopResultsHeader, getTrendingBrandsHeader, getTrendingSearchesHeader, KEY_EVENT_VALUE, MAX_DESKTOP_SUGGESTION_BRANDS_OVERFLOW, MAX_DESKTOP_SUGGESTION_ITEM_PER_SECTION, MAX_DESKTOP_SUGGESTION_QUERY_OVERFLOW, MAX_SEARCH_RECOMMENDATION_PER_SECTION, MAX_SECTION_RESULT_SIZE, MAX_SPLIT_SECTION_RESULT_SIZE, MAX_SUGGESTION_BRAND_SUGGESTIONS, MAX_SUGGESTION_ITEMS_PER_SECTION, MAX_SUGGESTION_TOP_RESULTS, RESULT_DROPDOWN_SVG_ICON_PROPS, RETURN_KEY, TAB_KEY } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/consts";
import { ImageSearchPill } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/ImageSearchPill";
import { ResultDropdownImageIconItem } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultDropdownImageIconItem";
import { ResultDropdownImageItem } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultDropdownImageItem";
import { ResultDropdownImageSearchItem } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultDropdownImageSearchItem";
import { ResultDropdownItem } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultDropdownItem";
import { ResultsDropdownSectionWrapper } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultDropdownSectionWrapper";
import { buildQueriesSuggestionArray } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultsDropdownUtils";
import StringHighlight from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/StringHighlight/index";
import { decodeMultimodalQueryText } from "@faire/retailer-visitor-shared/features/MultimodalProductSearch/multimodalQuery";
import { useSearchSuggestionsData } from "@faire/retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/useSearchSuggestionsData";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import preloadLazySearchPage from "@faire/retailer-visitor-shared/lib/lazyPreload_DO_NOT_RENAME/searchPage";
import { localizedUrlWithQueryParams } from "@faire/retailer-visitor-shared/lib/pathUtils";
import { discoverSearch } from "@faire/retailer-visitor-shared/lib/seoPaths";
import { brandPage } from "@faire/retailer-visitor-shared/paths/index";
import { trackBrandClick, trackProductClick } from "@faire/retailer-visitor-shared/services/Events";
import { useSettingLISPHoverThreshold, useSettingLISPShortHoverThreshold } from "@faire/retailer-visitor-shared/settings/getSettingLISPHoverThreshold";
import { getSettingMaxNumBrandSuggestionsConfig } from "@faire/retailer-visitor-shared/settings/getSettingMaxNumBrandSuggestionsConfig";
import { getSettingMaxNumSearchQuerySuggestionsConfig } from "@faire/retailer-visitor-shared/settings/getSettingMaxNumSearchQuerySuggestionsConfig";
import { assignSettingR2BAwardConfiguration } from "@faire/retailer-visitor-shared/settings/getSettingR2BAwardConfiguration";
import { shouldShowRscProductTileLoggedInSearchPage } from "@faire/retailer-visitor-shared/settings/getSettingRscProductTileLoggedInSearchPage";
import { useAssignSettingSearchSuggestionHoverSpeculationRelaunch, useSettingSearchSuggestionHoverSpeculationRelaunch } from "@faire/retailer-visitor-shared/settings/useSettingSearchSuggestionHoverSpeculation";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useR2BAwardStore } from "@faire/retailer-visitor-shared/stores/domain/useR2BAwardStore";
import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { isTouchDevice } from "@faire/web--source/common/isTouchDevice";
import { DEPRECATED_backwardsCompatibleValues, useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { isRobot } from "@faire/web--source/common/user-agent/isRobot";
import { Opacity } from "@faire/web--source/slate/Color";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { Clock } from "@faire/web--source/slate/icons/foundation/Clock";
import { Search } from "@faire/web--source/slate/icons/foundation/Search";
import { HorizontalLine, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { getWindowHeight, getWindowWidth } from "@faire/web--source/ui/hooks/useObservableWindow";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { trackR2BReferralsEntrySearchDropdown } from "@faire/web-api--source/events/r2BReferrals/actionUnknown/entrySearchDropdown";
import { trackSearchSuggestionClick } from "@faire/web-api--source/events/search/click/suggestion";
import { trackSearchSearchSuggestionLoadedView } from "@faire/web-api--source/events/search/view/searchSuggestionLoaded";
import { trackSearchSuggestionsView } from "@faire/web-api--source/events/search/view/suggestions";
import { ISearchRequestReferrer } from "@faire/web-api--source/indigofair/data/ISearchRequestReferrer";
import { ISearchSuggestionHoverXP } from "@faire/web-api--source/indigofair/data/ISearchSuggestionHoverXP";
import { path as c1CategoryPath } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import productSearch, { route as searchRoute } from "@faire/web-api--source/routes/www/search";
import userBrandReferrals from "@faire/web-api--source/routes/www/user/brand-referrals";
import { observer } from "mobx-react";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import styled from "styled-components";
export var ResultsDropdown = function(props) {
    var _useSearchSuggestionsData = useSearchSuggestionsData(), searchSuggestionResponse = _useSearchSuggestionsData.searchSuggestionResponse, startTimingMarker = _useSearchSuggestionsData.startTimingMarker, query = _useSearchSuggestionsData.query;
    var recentSearches = searchSuggestionResponse.recent_searches;
    return /*#__PURE__*/ _jsx(ResultsDropdownWithoutDataFetching, _object_spread_props(_object_spread({}, props), {
        suggestions: searchSuggestionResponse,
        startTimingMarker: startTimingMarker,
        recentSearches: recentSearches,
        query: query || props.query
    }));
};
var ResultsDropdownBase = function(param) {
    var submit = param.submit, parent = param.parent, dontShowSearch = param.dontShowSearch, recentSearches = param.recentSearches, deleteRecentSearchQuery = param.deleteRecentSearchQuery, deleteIdx = param.deleteIdx, startTimingMarker = param.startTimingMarker, searchElement = param.searchElement, cancelSearch = param.cancelSearch, query = param.query, suggestions = param.suggestions;
    var _getWindow;
    var viewport = useViewport();
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useTopOfPageContent = useTopOfPageContent(), topOffset = _useTopOfPageContent.headerHeight;
    var r2bAdvertisedRetailerAwardFormatted = useR2BAwardStore().r2bAdvertisedRetailerAwardFormatted;
    var prevQuery = useRef(undefined);
    var prevSuggestions = useRef(undefined);
    var _useState = _sliced_to_array(useState(false), 2), displaySeeAllResults = _useState[0], setDisplaySeeAllResults = _useState[1];
    var _useState1 = _sliced_to_array(useState(-1), 2), selected = _useState1[0], setSelected = _useState1[1];
    var parentRect = useRef(parent ? parent.getBoundingClientRect() : null);
    var currentIdx = useRef(0);
    var sectionIdMap = useRef({});
    sectionIdMap.current = getSectionIdMap(strictLocalize);
    var shouldEnableSuggestionsImpressionAllocationV2 = viewport.isDesktopAndAbove && isLoggedInRetailer();
    var PREFETCH_DELAY_MS = useSettingLISPHoverThreshold();
    var PREFETCH_DELAY_MS_SHORT = useSettingLISPShortHoverThreshold();
    var _useNextRouterContext = useNextRouterContext(), nextPrefetch = _useNextRouterContext.prefetch;
    var isRSCSearchPage = shouldShowRscProductTileLoggedInSearchPage();
    var prefetchOnHoverBucket = useSettingSearchSuggestionHoverSpeculationRelaunch();
    var assignPrefetchBucket = useAssignSettingSearchSuggestionHoverSpeculationRelaunch();
    var timeoutRef = React.useRef(undefined);
    // this is used to reset the dropdown to top
    var reference = useRef(null);
    useEffect(function() {
        var _prevSuggestions_current;
        if (((_prevSuggestions_current = prevSuggestions.current) === null || _prevSuggestions_current === void 0 ? void 0 : _prevSuggestions_current.request_id) !== suggestions.request_id && startTimingMarker) {
            var timingPair = {
                start: startTimingMarker
            };
            trackSearchSearchSuggestionLoadedView(timingPair);
        }
    }, [
        startTimingMarker,
        suggestions.request_id
    ]);
    useEffect(function() {
        if (viewport.isMobile) {
            if (prevQuery.current !== query) {
                var _reference_current_scrollTo, _reference_current;
                (_reference_current = reference.current) === null || _reference_current === void 0 ? void 0 : (_reference_current_scrollTo = _reference_current.scrollTo) === null || _reference_current_scrollTo === void 0 ? void 0 : _reference_current_scrollTo.call(_reference_current, 0, 0);
            }
        }
    }, [
        query,
        viewport.isMobile
    ]);
    useEffect(function() {
        prevQuery.current = query;
        prevSuggestions.current = suggestions;
    }, [
        query,
        suggestions
    ]);
    var buildSuggestions = useCallback(function(suggestionsResult) {
        var _suggestionsResult_suggested_brands, _suggestionSections_getSuggestedTermsHeader, _suggestionSections_getBrandsHeader, _suggestionSections_getTopResultsHeader;
        if (!suggestionsResult) {
            return {};
        }
        var suggestionSections = {};
        var numberOfOverflowQuerySuggestions = Math.max(0, getSettingMaxNumBrandSuggestionsConfig() - ((_suggestionsResult_suggested_brands = suggestionsResult.suggested_brands) === null || _suggestionsResult_suggested_brands === void 0 ? void 0 : _suggestionsResult_suggested_brands.length));
        var increasedNumberOfQuerySuggestions = Math.min(getSettingMaxNumSearchQuerySuggestionsConfig() + MAX_DESKTOP_SUGGESTION_QUERY_OVERFLOW, getSettingMaxNumSearchQuerySuggestionsConfig() + numberOfOverflowQuerySuggestions);
        var maxNumberOfQuerySuggestions = shouldEnableSuggestionsImpressionAllocationV2 ? increasedNumberOfQuerySuggestions : MAX_SECTION_RESULT_SIZE;
        var maxNumberOfQueryAndCategorySuggestions = shouldEnableSuggestionsImpressionAllocationV2 ? increasedNumberOfQuerySuggestions : MAX_SUGGESTION_ITEMS_PER_SECTION;
        var _suggestionsResult_suggested_search_queries, _suggestionsResult_suggested_category_queries;
        var suggestedSearchQueriesSuggestionArray = buildQueriesSuggestionArray((_suggestionsResult_suggested_search_queries = suggestionsResult.suggested_search_queries) !== null && _suggestionsResult_suggested_search_queries !== void 0 ? _suggestionsResult_suggested_search_queries : {}, getSuggestedTermsHeader(strictLocalize), suggestionsResult.request_id, maxNumberOfQuerySuggestions, strictLocalize).concat(categoryQueriesSuggestionArray((_suggestionsResult_suggested_category_queries = suggestionsResult.suggested_category_queries) !== null && _suggestionsResult_suggested_category_queries !== void 0 ? _suggestionsResult_suggested_category_queries : {}, getSuggestedTermsHeader(strictLocalize), suggestionsResult.request_id)).slice(0, maxNumberOfQueryAndCategorySuggestions);
        var _suggestionsResult_recent_searches;
        var recentSearchesSuggestionArray = searchesSuggestionArray((_suggestionsResult_recent_searches = suggestionsResult.recent_searches) !== null && _suggestionsResult_recent_searches !== void 0 ? _suggestionsResult_recent_searches : [], getRecentSearchesHeader(strictLocalize), ISearchRequestReferrer.SearchRequestReferrerType.SUGGESTIONS_RECENT_SEARCHES, suggestionsResult.request_id);
        // Recent searches
        suggestionSections[getRecentSearchesHeader(strictLocalize)] = recentSearchesSuggestionArray;
        // Suggestions that go both to search and to browse with filters.
        suggestionSections[getSuggestedTermsHeader(strictLocalize)] = suggestedSearchQueriesSuggestionArray;
        var numberOfTrendingBrands = MAX_SUGGESTION_ITEMS_PER_SECTION;
        if (!query) {
            suggestionSections[getBrandsYouMightKnowHeader(strictLocalize)] = brandsSuggestionArray(suggestionsResult.brands_you_may_know, getBrandsYouMightKnowHeader(strictLocalize), suggestionsResult.request_id);
        }
        // Show new trending searches section if search recommendations is returned
        if (shouldShowSearchRecommendations(suggestionsResult.search_recommendations)) {
            var _suggestionsResult_search_recommendations;
            // Suggested Searches
            suggestionSections[getTrendingSearchesHeader(strictLocalize)] = searchTrendingSearchesArray((_suggestionsResult_search_recommendations = suggestionsResult.search_recommendations) !== null && _suggestionsResult_search_recommendations !== void 0 ? _suggestionsResult_search_recommendations : [], getTrendingSearchesHeader(strictLocalize), suggestionsResult.request_id).slice(0, MAX_SEARCH_RECOMMENDATION_PER_SECTION);
            numberOfTrendingBrands = MAX_DESKTOP_SUGGESTION_ITEM_PER_SECTION;
        }
        if (viewport.isMobile && !query) {
            var _suggestionsResult_recently_viewed_products;
            // Recently viewed
            suggestionSections[getRecentlyViewedHeader(strictLocalize)] = productSuggestionArray((_suggestionsResult_recently_viewed_products = suggestionsResult.recently_viewed_products) !== null && _suggestionsResult_recently_viewed_products !== void 0 ? _suggestionsResult_recently_viewed_products : [], getRecentlyViewedHeader(strictLocalize)).slice(0, MAX_SUGGESTION_ITEMS_PER_SECTION);
            // Show the old trending searches sections if no search recommendations are returned
            if (!shouldShowSearchRecommendations(suggestionsResult.search_recommendations)) {
                var _suggestionsResult_trending_searches;
                // Trending searches
                suggestionSections[getTrendingSearchesHeader(strictLocalize)] = searchesSuggestionArray((_suggestionsResult_trending_searches = suggestionsResult.trending_searches) !== null && _suggestionsResult_trending_searches !== void 0 ? _suggestionsResult_trending_searches : [], getTrendingSearchesHeader(strictLocalize), ISearchRequestReferrer.SearchRequestReferrerType.SUGGESTIONS_TRENDING_SEARCHES, suggestionsResult.request_id).slice(0, MAX_SPLIT_SECTION_RESULT_SIZE);
            }
        }
        var numberOfOverflowBrandSuggestions = Math.max(0, getSettingMaxNumSearchQuerySuggestionsConfig() - Object.keys(suggestionsResult.suggested_search_queries).length);
        var increasedNumberOfBrandSuggestions = Math.min(getSettingMaxNumBrandSuggestionsConfig() + MAX_DESKTOP_SUGGESTION_BRANDS_OVERFLOW, getSettingMaxNumBrandSuggestionsConfig() + numberOfOverflowBrandSuggestions);
        var maxNumberOfBrandSuggestions = shouldEnableSuggestionsImpressionAllocationV2 ? increasedNumberOfBrandSuggestions : numberOfTrendingBrands;
        var _suggestionsResult_suggested_brands1;
        suggestionSections[query ? getBrandsHeader(strictLocalize) : getTrendingBrandsHeader(strictLocalize)] = brandsSuggestionArray((_suggestionsResult_suggested_brands1 = suggestionsResult.suggested_brands) !== null && _suggestionsResult_suggested_brands1 !== void 0 ? _suggestionsResult_suggested_brands1 : [], query ? getBrandsHeader(strictLocalize) : getTrendingBrandsHeader(strictLocalize), suggestionsResult.request_id).slice(0, maxNumberOfBrandSuggestions);
        if (viewport.isMobile && query && isLoggedInRetailer()) {
            var _suggestionsResult_top_search_results;
            // Top Results
            suggestionSections[getTopResultsHeader(strictLocalize)] = productSuggestionArray((_suggestionsResult_top_search_results = suggestionsResult.top_search_results) !== null && _suggestionsResult_top_search_results !== void 0 ? _suggestionsResult_top_search_results : [], getTopResultsHeader(strictLocalize)).slice(0, MAX_SUGGESTION_TOP_RESULTS);
        }
        var _suggestionSections_getSuggestedTermsHeader_length, _suggestionSections_getBrandsHeader_length, _suggestionSections_getTopResultsHeader_length;
        setDisplaySeeAllResults(viewport.isMobile && !!query && (((_suggestionSections_getSuggestedTermsHeader_length = (_suggestionSections_getSuggestedTermsHeader = suggestionSections[getSuggestedTermsHeader(strictLocalize)]) === null || _suggestionSections_getSuggestedTermsHeader === void 0 ? void 0 : _suggestionSections_getSuggestedTermsHeader.length) !== null && _suggestionSections_getSuggestedTermsHeader_length !== void 0 ? _suggestionSections_getSuggestedTermsHeader_length : 0) > 1 || ((_suggestionSections_getBrandsHeader_length = (_suggestionSections_getBrandsHeader = suggestionSections[getBrandsHeader(strictLocalize)]) === null || _suggestionSections_getBrandsHeader === void 0 ? void 0 : _suggestionSections_getBrandsHeader.length) !== null && _suggestionSections_getBrandsHeader_length !== void 0 ? _suggestionSections_getBrandsHeader_length : 0) > 1 || isLoggedInRetailer() && ((_suggestionSections_getTopResultsHeader_length = (_suggestionSections_getTopResultsHeader = suggestionSections[getTopResultsHeader(strictLocalize)]) === null || _suggestionSections_getTopResultsHeader === void 0 ? void 0 : _suggestionSections_getTopResultsHeader.length) !== null && _suggestionSections_getTopResultsHeader_length !== void 0 ? _suggestionSections_getTopResultsHeader_length : 0) > 1));
        return suggestionSections;
    }, [
        query,
        shouldEnableSuggestionsImpressionAllocationV2,
        strictLocalize,
        viewport.isMobile
    ]);
    var parsedSuggestions = useMemo(function() {
        return buildSuggestions(suggestions);
    }, [
        buildSuggestions,
        suggestions
    ]);
    var shouldShowR2B = useMemo(function() {
        return suggestions.show_r2_b_banner;
    }, [
        suggestions
    ]);
    var entryCount = entryCountFromSuggestions(parsedSuggestions);
    var getSuggestionUrl = function(url) {
        if (!url.startsWith("/")) {
            var urlPrefix = RetailerStore.get().retailerToken ? "/retailer/".concat(RetailerStore.get().retailerToken) : "/";
            url = "".concat(urlPrefix).concat(url);
        }
        return url.replace("//", "/");
    };
    var onSuggestionClicked = useCallback(function(suggestion) {
        var navigate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true // whether to explicitly navigate to the suggestion url
        ;
        clearTimeout(timeoutRef.current);
        // User selected an autocompleted search query (suggested terms & recent searches)
        if (suggestion.sectionName === getSuggestedTermsHeader(strictLocalize)) {
            trackEvent("/clicked-suggestion/query/".concat(suggestion.searchData.query));
        // User select Recent searches
        // have the same event track path as suggested term because old version is doing this
        } else if (suggestion.sectionName === getRecentSearchesHeader(strictLocalize)) {
            trackEvent("/clicked-suggestion/query/".concat(suggestion.label));
        // User select trending searches
        } else if (suggestion.sectionName === getTrendingSearchesHeader(strictLocalize)) {
            if (shouldShowSearchRecommendations(suggestions === null || suggestions === void 0 ? void 0 : suggestions.search_recommendations)) {
                trackEvent("/clicked-suggestion/query/v2/trending-searches/".concat(suggestion.label));
            } else {
                trackEvent("/clicked-suggestion/query/trending-searches/".concat(suggestion.searchData));
            }
        } else if (suggestion.sectionName === getTrendingBrandsHeader(strictLocalize) || suggestion.sectionName === getBrandsHeader(strictLocalize)) {
            trackEvent("/clicked-suggestion/brand/".concat(suggestion.searchData.token));
            var _suggestion_searchData_token;
            trackBrandClick((_suggestion_searchData_token = suggestion.searchData.token) !== null && _suggestion_searchData_token !== void 0 ? _suggestion_searchData_token : "", "header_search", suggestions.request_id);
        } else if (suggestion.sectionName === getRecentlyViewedHeader(strictLocalize) || suggestion.sectionName === getTopResultsHeader(strictLocalize)) {
            trackEvent(suggestion.sectionName === getRecentlyViewedHeader(strictLocalize) ? "/clicked-suggestion/product/recently-viewed/".concat(suggestion.searchData.token) : "/clicked-suggestion/product/top-results/".concat(suggestion.searchData.token));
            var _suggestion_searchData_token1;
            trackProductClick((_suggestion_searchData_token1 = suggestion.searchData.token) !== null && _suggestion_searchData_token1 !== void 0 ? _suggestion_searchData_token1 : "", "header_search", suggestions.request_id);
        }
        var _suggestion_searchData_query;
        submit((_suggestion_searchData_query = suggestion.searchData.query) !== null && _suggestion_searchData_query !== void 0 ? _suggestion_searchData_query : "", getSuggestionUrl(suggestion.url), navigate);
    }, [
        strictLocalize,
        submit,
        suggestions.request_id,
        suggestions === null || suggestions === void 0 ? void 0 : suggestions.search_recommendations
    ]);
    var isElementInContainer = useCallback(function(element) {
        var _element_getBoundingClientRect = element.getBoundingClientRect(), elementLeft = _element_getBoundingClientRect.left, elementRight = _element_getBoundingClientRect.right, elementTop = _element_getBoundingClientRect.top;
        var _parentRect_current;
        var _ref = (_parentRect_current = parentRect.current) !== null && _parentRect_current !== void 0 ? _parentRect_current : {
            left: 0,
            right: 0,
            top: 0
        }, containerLeft = _ref.left, containerRight = _ref.right, containerTop = _ref.top;
        return elementLeft >= containerLeft && elementRight <= containerRight && elementTop >= containerTop;
    }, [
        parentRect
    ]);
    var handleSuggestionBlur = useCallback(function() {
        clearTimeout(timeoutRef.current);
    }, []);
    var handleSuggestionHover = useCallback(function(selectedIdx) {
        if (selectedIdx < 0) {
            setSelected(-1);
            return;
        }
        if (selectedIdx >= entryCount) {
            setSelected(entryCount - 1);
        } else {
            setSelected(selectedIdx);
        }
        var allSuggestions = Object.values(parsedSuggestions).reduce(function(result, array) {
            return _to_consumable_array(result).concat(_to_consumable_array(array));
        }, []);
        var currentSelection = allSuggestions[selectedIdx];
        if (isRSCSearchPage) {
            assignPrefetchBucket();
            var shouldPrefetch = prefetchOnHoverBucket !== ISearchSuggestionHoverXP.Bucket.CONTROL;
            var prefetchDelay = 0;
            if (prefetchOnHoverBucket === ISearchSuggestionHoverXP.Bucket.TREATMENT_A) {
                prefetchDelay = PREFETCH_DELAY_MS;
            } else if (prefetchOnHoverBucket === ISearchSuggestionHoverXP.Bucket.TREATMENT_B) {
                prefetchDelay = PREFETCH_DELAY_MS_SHORT;
            }
            timeoutRef.current = setTimeout(function() {
                if ((currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.url) && shouldPrefetch) {
                    nextPrefetch(currentSelection.url, {
                        kind: PrefetchKind.FULL
                    });
                }
            }, prefetchDelay);
        }
    }, [
        entryCount,
        prefetchOnHoverBucket,
        assignPrefetchBucket,
        parsedSuggestions,
        nextPrefetch,
        isRSCSearchPage,
        PREFETCH_DELAY_MS,
        PREFETCH_DELAY_MS_SHORT
    ]);
    var onReturnPressed = useCallback(function() {
        if (selected >= 0) {
            var allSuggestions = Object.values(parsedSuggestions).reduce(function(result, array) {
                return _to_consumable_array(result).concat(_to_consumable_array(array));
            }, []);
            var currentSelection = allSuggestions[selected];
            if (currentSelection) {
                onSuggestionClicked(currentSelection);
            }
        } else if (query) {
            submit(query);
        }
        if (searchElement) {
            searchElement.blur();
        }
    }, [
        selected,
        query,
        searchElement,
        parsedSuggestions,
        onSuggestionClicked,
        submit
    ]);
    var keyDown = useCallback(function(event) {
        if (event.type !== KEY_EVENT_VALUE) {
            return;
        }
        if (event.keyCode !== ARROW_UP && event.keyCode !== ARROW_DOWN && event.keyCode !== RETURN_KEY && event.keyCode !== TAB_KEY) {
            return;
        }
        // The parent search bar is also handling RETURN_KEY to execute searches.
        // So stop propagation in cases of hitting RETURN on a suggestion.
        event.stopPropagation();
        switch(event.keyCode){
            case ARROW_UP:
                event.preventDefault();
                handleSuggestionBlur();
                handleSuggestionHover(selected - 1);
                break;
            case ARROW_DOWN:
                event.preventDefault();
                handleSuggestionBlur();
                handleSuggestionHover(selected + 1);
                break;
            case RETURN_KEY:
                onReturnPressed();
                break;
            case TAB_KEY:
                if (!isElementInContainer(event.target)) {
                    dontShowSearch();
                }
                break;
            default:
                break;
        }
    }, [
        dontShowSearch,
        isElementInContainer,
        onReturnPressed,
        selected,
        handleSuggestionHover,
        handleSuggestionBlur
    ]);
    // splitting up the useeffect
    useEffect(function() {
        assignSettingR2BAwardConfiguration();
        if (getGlobalProperty("isNextJS", false) && !isRobot()) {
            nextPrefetch(searchRoute);
        } else {
            preloadLazySearchPage();
        }
    }, [
        nextPrefetch
    ]);
    useEffect(function() {
        var _getWindow;
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener(KEY_EVENT_VALUE, keyDown, {
            capture: true
        });
        return function() {
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.removeEventListener(KEY_EVENT_VALUE, keyDown, {
                capture: true
            });
            if (isTouchDevice() && viewport.isMobile) {
                var _getWindow1;
                (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : _getWindow1.removeEventListener("touchstart", removeFocusOnTopSearchWhenTouchStart, {
                    capture: true
                });
            }
        };
    }, [
        keyDown,
        viewport.isMobile
    ]);
    useEffect(function() {
        parentRect.current = parent ? parent.getBoundingClientRect() : null;
    }, [
        parent
    ]);
    useEffect(function() {
        if (isTouchDevice() && viewport.isMobile) {
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener("touchstart", removeFocusOnTopSearchWhenTouchStart, {
                capture: true
            });
        }
    }, [
        viewport.isMobile
    ]);
    var haveSuggestions = function() {
        return entryCount > 0;
    };
    var buildImageItem = useCallback(function(suggestion, isProduct, onClick, shouldEnableSuggestionsImpressionAllocationV2) {
        var indx = currentIdx.current++;
        return /*#__PURE__*/ _jsx(ResultDropdownImageItem, {
            selected: indx === selected,
            index: indx,
            onHover: handleSuggestionHover,
            onMouseLeave: handleSuggestionBlur,
            onClick: onClick,
            suggestion: suggestion,
            isProduct: isProduct,
            shouldEnableSuggestionsImpressionAllocationV2: shouldEnableSuggestionsImpressionAllocationV2
        }, suggestion.url + indx.toString());
    }, [
        selected,
        handleSuggestionHover,
        handleSuggestionBlur
    ]);
    var buildImageIconItem = useCallback(function(suggestion, onClick) {
        var indx = currentIdx.current++;
        return /*#__PURE__*/ _jsx(ResultDropdownImageIconItem, {
            suggestion: suggestion,
            selected: indx === selected,
            onHover: function() {
                return handleSuggestionHover(indx);
            },
            onMouseLeave: handleSuggestionBlur,
            onClick: onClick
        }, suggestion.url + indx.toString());
    }, [
        selected,
        handleSuggestionHover,
        handleSuggestionBlur
    ]);
    var buildTrendingSearchImageItem = useCallback(function(suggestion) {
        var indx = currentIdx.current++;
        return /*#__PURE__*/ _jsx(ImageSearchPill, {
            selected: indx === selected,
            onHover: function() {
                return handleSuggestionHover(indx);
            },
            onMouseLeave: function() {
                handleSuggestionBlur();
                handleSuggestionHover(-1);
            },
            onClick: function() {
                return onSuggestionClicked(suggestion, false);
            },
            suggestion: suggestion,
            url: getSuggestionUrl(suggestion.url),
            dataTestId: "search-recommendation-pill"
        }, suggestion.url + indx.toString());
    }, [
        onSuggestionClicked,
        selected,
        handleSuggestionHover,
        handleSuggestionBlur
    ]);
    var buildSuggestedTermsItem = useCallback(function(suggestion, onClick, shouldEnableSuggestionsImpressionAllocationV2) {
        var indx = currentIdx.current++;
        return /*#__PURE__*/ _jsx(ResultDropdownImageSearchItem, {
            onHover: function() {
                return handleSuggestionHover(indx);
            },
            onMouseLeave: handleSuggestionBlur,
            onClick: onClick,
            suggestion: suggestion,
            image: /*#__PURE__*/ _jsx(Search, _object_spread({}, RESULT_DROPDOWN_SVG_ICON_PROPS)),
            reverseHighlightText: query,
            selected: indx === selected,
            shouldEnableSuggestionsImpressionAllocationV2: shouldEnableSuggestionsImpressionAllocationV2
        }, suggestion.url + indx.toString());
    }, [
        query,
        selected,
        handleSuggestionHover,
        handleSuggestionBlur
    ]);
    var buildFullWidthTrendingSearchesItem = useCallback(function(suggestion, onClick) {
        var _suggestion_searchData_image, _suggestion_searchData;
        var indx = currentIdx.current++;
        return /*#__PURE__*/ _jsx(ResultDropdownImageSearchItem, {
            suggestion: suggestion,
            onHover: function() {
                return handleSuggestionHover(indx);
            },
            onMouseLeave: handleSuggestionBlur,
            onClick: onClick,
            image: optimizeImageUrl({
                url: (_suggestion_searchData = suggestion.searchData) === null || _suggestion_searchData === void 0 ? void 0 : (_suggestion_searchData_image = _suggestion_searchData.image) === null || _suggestion_searchData_image === void 0 ? void 0 : _suggestion_searchData_image.url
            }, false, {
                height: 40,
                width: 40,
                resizeMethod: "fill"
            }),
            selected: indx === selected
        }, suggestion.url + indx.toString());
    }, [
        selected,
        handleSuggestionHover,
        handleSuggestionBlur
    ]);
    var buildRecentSearchesImageItem = useCallback(function(suggestion) {
        var indx = currentIdx.current++;
        return /*#__PURE__*/ _jsx(ImageSearchPill, {
            onHover: function() {
                return handleSuggestionHover(indx);
            },
            onMouseLeave: function() {
                handleSuggestionBlur();
                handleSuggestionHover(-1);
            },
            onClick: function() {
                return onSuggestionClicked(suggestion, false);
            },
            onDelete: function() {
                return deleteRecentSearchQuery(suggestion.label, indx, recentSearches !== null && recentSearches !== void 0 ? recentSearches : []);
            },
            isDeleting: deleteIdx === indx,
            suggestion: suggestion,
            selected: indx === selected,
            svgIcon: /*#__PURE__*/ _jsx(Clock, _object_spread({}, RESULT_DROPDOWN_SVG_ICON_PROPS)),
            url: getSuggestionUrl(suggestion.url),
            dataTestId: "recent-search-recommendation-pill"
        }, suggestion.url + indx.toString());
    }, [
        deleteIdx,
        deleteRecentSearchQuery,
        onSuggestionClicked,
        recentSearches,
        selected,
        handleSuggestionHover,
        handleSuggestionBlur
    ]);
    var buildFullWidthRecentSearchesItem = useCallback(function(suggestion, onClick) {
        var indx = currentIdx.current++;
        return /*#__PURE__*/ _jsx(ResultDropdownImageSearchItem, {
            onHover: function() {
                return handleSuggestionHover(indx);
            },
            onMouseLeave: handleSuggestionBlur,
            onClick: onClick,
            onDelete: function() {
                return deleteRecentSearchQuery(suggestion.label, indx, recentSearches !== null && recentSearches !== void 0 ? recentSearches : []);
            },
            isDeleting: deleteIdx === indx,
            suggestion: suggestion,
            image: /*#__PURE__*/ _jsx(Clock, _object_spread({}, RESULT_DROPDOWN_SVG_ICON_PROPS)),
            selected: indx === selected
        }, suggestion.url + indx.toString());
    }, [
        deleteIdx,
        deleteRecentSearchQuery,
        recentSearches,
        selected,
        handleSuggestionHover,
        handleSuggestionBlur
    ]);
    var trackView = useCallback(function(sectionHeader, suggestionArray, sectionIndex) {
        var _suggestionArray_;
        var requestId = (_suggestionArray_ = suggestionArray[0]) === null || _suggestionArray_ === void 0 ? void 0 : _suggestionArray_.requestID;
        if (shouldPerformPeteEventTracking(sectionHeader, strictLocalize)) {
            var containerName = getContainerName(sectionHeader, strictLocalize);
            var suggestionEventTokenArray = suggestionArray.map(function(suggestion) {
                return getSuggestionEventToken(sectionHeader, suggestion, strictLocalize);
            }).filter(isNotUndefined);
            if (suggestionEventTokenArray.length > 0) {
                var token = "".concat(query, "|").concat(suggestionEventTokenArray.join("|"));
                trackSearchSuggestionsView("".concat(containerName, "|").concat(sectionIndex), requestId !== null && requestId !== void 0 ? requestId : "", token);
            }
        }
    }, [
        query,
        strictLocalize
    ]);
    var trackClick = useCallback(function(sectionHeader, sectionIndex, suggestion, suggestionIndex) {
        var navigate = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
        var requestId = suggestion.requestID;
        if (shouldPerformPeteEventTracking(sectionHeader, strictLocalize)) {
            var suggestionEventToken = getSuggestionEventToken(sectionHeader, suggestion, strictLocalize);
            if (suggestionEventToken !== undefined) {
                var containerName = getContainerName(sectionHeader, strictLocalize);
                var token = "".concat(query, "|").concat(suggestionEventToken, "|").concat(suggestionIndex);
                trackSearchSuggestionClick("".concat(containerName, "|").concat(sectionIndex), requestId !== null && requestId !== void 0 ? requestId : "", token);
            }
        }
        /**
         * Perform legacy event tracking.
         * We will eventually refactor all of the legacy event tracking with PETE.
         */ onSuggestionClicked(suggestion, navigate);
    }, [
        onSuggestionClicked,
        query,
        strictLocalize
    ]);
    var renderDropdownSection = useCallback(function(sectionHeader, suggestionArray, sectionIndex) {
        // Check to see if search recommendations is returned
        if (sectionHeader === getTrendingSearchesHeader(strictLocalize) && shouldShowSearchRecommendations(suggestions === null || suggestions === void 0 ? void 0 : suggestions.search_recommendations)) {
            if (viewport.isTabletAndAbove) {
                return /*#__PURE__*/ _jsx(BrandsYouMightKnowRow, {
                    sectionHeader: sectionHeader,
                    suggestionArray: suggestionArray,
                    trackView: trackView,
                    sectionIndex: sectionIndex,
                    buildTrendingSearchImageItem: buildTrendingSearchImageItem
                });
            }
        } else if (viewport.isTabletAndAbove && sectionHeader === getRecentSearchesHeader(strictLocalize)) {
            return /*#__PURE__*/ _jsx(BrandsYouMightKnowRow, {
                sectionHeader: sectionHeader,
                suggestionArray: suggestionArray,
                trackView: trackView,
                sectionIndex: sectionIndex,
                buildRecentSearchesImageItem: buildRecentSearchesImageItem
            });
        }
        if (sectionHeader === getBrandsYouMightKnowHeader(strictLocalize) && viewport.isTabletAndAbove) {
            return /*#__PURE__*/ _jsx(BrandsYouMightKnowRow, {
                sectionHeader: sectionHeader,
                suggestionArray: suggestionArray,
                trackView: trackView,
                sectionIndex: sectionIndex,
                buildImageIconItem: buildImageIconItem,
                trackClick: trackClick
            });
        }
        return /*#__PURE__*/ _jsx(ResultsDropdownSectionWrapper, {
            sectionHeader: sectionHeader,
            suggestionArray: suggestionArray,
            sectionIndex: sectionIndex,
            trackView: trackView,
            children: /*#__PURE__*/ _jsx("ul", {
                "data-test-id": sectionHeader.toLowerCase().replace(" ", "-"),
                children: suggestionArray.map(function(suggestion, suggestionIndex) {
                    var trackClickCallback = function() {
                        return trackClick(sectionHeader, sectionIndex, suggestion, suggestionIndex, false);
                    };
                    switch(sectionHeader){
                        case getRecentSearchesHeader(strictLocalize):
                            return buildFullWidthRecentSearchesItem(suggestion, trackClickCallback);
                        case getBrandsYouMightKnowHeader(strictLocalize):
                            return buildImageIconItem(suggestion, trackClickCallback);
                        case getTopResultsHeader(strictLocalize):
                        case getRecentlyViewedHeader(strictLocalize):
                            return buildImageItem(suggestion, true, trackClickCallback);
                        case getTrendingBrandsHeader(strictLocalize):
                        case getBrandsHeader(strictLocalize):
                            return buildImageItem(suggestion, false, trackClickCallback, shouldEnableSuggestionsImpressionAllocationV2);
                        case getTrendingSearchesHeader(strictLocalize):
                            return buildFullWidthTrendingSearchesItem(suggestion, trackClickCallback);
                        case getSuggestedTermsHeader(strictLocalize):
                            return buildSuggestedTermsItem(suggestion, trackClickCallback, shouldEnableSuggestionsImpressionAllocationV2);
                        default:
                            currentIdx.current++;
                            return /*#__PURE__*/ _jsx(ResultDropdownItem, {
                                index: currentIdx.current,
                                onHover: handleSuggestionHover,
                                onMouseLeave: handleSuggestionBlur,
                                onClick: onSuggestionClicked,
                                suggestion: suggestion,
                                children: /*#__PURE__*/ _jsx(StringHighlight, {
                                    message: suggestion.label,
                                    highlight: query
                                })
                            }, suggestion.url + currentIdx.toString());
                    }
                })
            })
        });
    }, [
        strictLocalize,
        suggestions === null || suggestions === void 0 ? void 0 : suggestions.search_recommendations,
        viewport.isTabletAndAbove,
        trackView,
        buildTrendingSearchImageItem,
        buildRecentSearchesImageItem,
        buildImageIconItem,
        trackClick,
        buildFullWidthRecentSearchesItem,
        buildImageItem,
        shouldEnableSuggestionsImpressionAllocationV2,
        buildFullWidthTrendingSearchesItem,
        buildSuggestedTermsItem,
        handleSuggestionHover,
        handleSuggestionBlur,
        onSuggestionClicked,
        query
    ]);
    var getHeading = function(sectionHeader) {
        return /*#__PURE__*/ _jsxs(ResultsDropdownSectionHeaderWrapper, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    width: "2x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraphSansMedium",
                    role: "heading",
                    children: sectionHeader
                })
            ]
        });
    };
    var buildDropdownSections = useCallback(function(sectionHeader, suggestionArray, sectionIndex) {
        var shouldShowSectionHeader = sectionHeader && sectionHeader !== getSuggestedTermsHeader(strictLocalize);
        return /*#__PURE__*/ _jsxs(ResultsDropdownSectionsWrapper, {
            children: [
                shouldShowSectionHeader ? getHeading(sectionHeader) : null,
                /*#__PURE__*/ _jsx("div", {
                    children: renderDropdownSection(sectionHeader, suggestionArray, sectionIndex)
                })
            ]
        }, sectionHeader + sectionIndex.toString());
    }, [
        strictLocalize,
        renderDropdownSection
    ]);
    var suggestionSections = parsedSuggestions;
    var contents = useMemo(function() {
        return Object.entries(suggestionSections).filter(function(param) {
            var _param = _sliced_to_array(param, 2), _ = _param[0], suggestions = _param[1];
            return suggestions.length > 0;
        }).map(function(param, sectionIndex) {
            var _param = _sliced_to_array(param, 2), sectionHeader = _param[0], suggestions = _param[1];
            return buildDropdownSections(sectionHeader, suggestions, sectionIndex);
        });
    }, [
        buildDropdownSections,
        suggestionSections
    ]);
    currentIdx.current = 0;
    if (!haveSuggestions()) {
        return null;
    }
    currentIdx.current = 0;
    var viewProps = {
        $top: 60,
        $width: 500
    };
    if (parentRect && parentRect.current) {
        viewProps.$top = parentRect.current.height + 22;
        viewProps.$width = parentRect.current.width;
    }
    var showBackgroundOverlay = viewport.isTabletAndAbove || shouldEnableSuggestionsImpressionAllocationV2;
    var pageHeight = getWindowHeight() - topOffset;
    var _getWindow_document_body_scrollWidth;
    // Prefer to use the getWindow()?.document.body.scrollWidth() width of the viewport (if it exists), as this doesn't include the width of the scrollbar
    var pageWidth = (_getWindow_document_body_scrollWidth = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.document.body.scrollWidth) !== null && _getWindow_document_body_scrollWidth !== void 0 ? _getWindow_document_body_scrollWidth : getWindowWidth();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showBackgroundOverlay ? /*#__PURE__*/ _jsx("div", {
                style: {
                    position: "absolute",
                    top: "".concat(topOffset, "px"),
                    left: 0,
                    width: "".concat(pageWidth, "px"),
                    height: "".concat(pageHeight, "px"),
                    backgroundColor: Core.surface.hover + Opacity.O_50,
                    zIndex: -1
                },
                onClick: function() {
                    return cancelSearch();
                }
            }) : null,
            /*#__PURE__*/ _jsxs(ResultsDropdownView, _object_spread_props(_object_spread({}, viewProps), {
                ref: reference,
                children: [
                    contents,
                    displaySeeAllResults ? /*#__PURE__*/ _jsxs(AllResultWrapper, {
                        onClick: function() {
                            return submit(query);
                        },
                        children: [
                            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "4dmMpz",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "See all results for \""
                                    },
                                    {
                                        type: 1,
                                        value: "query"
                                    },
                                    {
                                        type: 0,
                                        value: "\""
                                    }
                                ],
                                values: DEPRECATED_backwardsCompatibleValues({
                                    query: query
                                })
                            }),
                            /*#__PURE__*/ _jsx(Chevron, {
                                width: "10px",
                                strokeWidth: "2.5px",
                                direction: "right",
                                stroke: Core.icon.subdued
                            })
                        ]
                    }) : null,
                    !isLoggedInRetailer() ? /*#__PURE__*/ _jsx(Spacer, {
                        height: 25
                    }) : null,
                    isLoggedInRetailer() && RetailerStore.get().showR2B && shouldShowR2B ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(R2MDivider, {
                                children: /*#__PURE__*/ _jsx(HorizontalLine, {})
                            }),
                            /*#__PURE__*/ _jsx(Link, {
                                to: userBrandReferrals(),
                                onClick: function() {
                                    cancelSearch();
                                    trackR2BReferralsEntrySearchDropdown();
                                },
                                children: /*#__PURE__*/ _jsxs(R2MPromoText, {
                                    onMouseOver: function() {
                                        return handleSuggestionHover(-1);
                                    },
                                    onMouseLeave: handleSuggestionBlur,
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                id: "v+PG/c",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "Not finding what you need?"
                                                    }
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            size: "1x"
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            color: Decorative.shade.orange,
                                            variant: "paragraphSansMedium",
                                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                id: "F/Uxzn",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "Refer brands and earn up to "
                                                    },
                                                    {
                                                        type: 1,
                                                        value: "amountMoney"
                                                    }
                                                ],
                                                values: {
                                                    amountMoney: r2bAdvertisedRetailerAwardFormatted
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    viewport.isMobile ? /*#__PURE__*/ _jsx(Spacer, {
                        height: 100
                    }) : null
                ]
            }))
        ]
    });
};
var categoryQueriesSuggestionArray = function(categoryQueries, sectionName, requestId) {
    return Object.keys(categoryQueries !== null && categoryQueries !== void 0 ? categoryQueries : {}).filter(function(suggestionKey) {
        var _categoryQueries_suggestionKey;
        return (_categoryQueries_suggestionKey = categoryQueries[suggestionKey]) === null || _categoryQueries_suggestionKey === void 0 ? void 0 : _categoryQueries_suggestionKey.category;
    }).map(function(suggestionKey) {
        var makersWithFiltersRequest = categoryQueries[suggestionKey];
        // `suggested_category_queries` only returns with category = "All Products"
        // This is only returned, when the locale is English.
        // https://fairewholesale.atlassian.net/browse/FD-40344?focusedCommentId=57566
        // Hence, we do not need to make any change here atm.
        var category = makersWithFiltersRequest.category;
        var obj = {
            label: suggestionKey,
            url: localizedUrlWithQueryParams(c1CategoryPath(category, {
                filters: [
                    buildFilterKeys(makersWithFiltersRequest.filter_keys)
                ]
            }), {
                refType: ISearchRequestReferrer.SearchRequestReferrerType.SUGGESTIONS_CATEGORY_QUERIES,
                refReqId: requestId
            }),
            sectionName: sectionName,
            searchData: ""
        };
        return obj;
    });
};
var suggestionBrandUrl = function(brandToken, obj) {
    if (isLoggedInRetailer()) {
        return brandPage(brandToken, obj);
    }
    return brandPage(brandToken, undefined, obj);
};
var brandsSuggestionArray = function(brandArray, sectionName, requestId) {
    return brandArray && brandArray.length > 0 ? brandArray.slice(0, MAX_SUGGESTION_BRAND_SUGGESTIONS).map(function(brandValue) {
        return {
            label: brandValue.name,
            url: suggestionBrandUrl(brandValue.token, {
                refType: ISearchRequestReferrer.SearchRequestReferrerType.SUGGESTIONS_BRANDS,
                refReqId: requestId
            }),
            sectionName: sectionName,
            searchData: brandValue,
            requestID: requestId
        };
    }) : [];
};
var shouldShowSearchRecommendations = function(searchRecommendations) {
    return searchRecommendations && (searchRecommendations === null || searchRecommendations === void 0 ? void 0 : searchRecommendations.length) > 0;
};
var searchesSuggestionArray = function(searchesArray, sectionName, type, requestId) {
    return searchesArray && searchesArray.length > 0 ? searchesArray.map(function(searchesValue) {
        return {
            label: decodeMultimodalQueryText(searchesValue),
            url: localizedUrlWithQueryParams(productSearch({
                q: searchesValue
            }), {
                refType: type,
                refReqId: requestId
            }),
            sectionName: sectionName,
            searchData: searchesValue,
            requestID: requestId
        };
    }) : [];
};
var productSuggestionArray = function(productArray, sectionName) {
    return productArray && productArray.length > 0 ? productArray.map(function(productValue) {
        return {
            label: productValue.name,
            url: "/product/".concat(productValue.token),
            sectionName: sectionName,
            searchData: productValue
        };
    }) : [];
};
var trendingSearchUrl = function(searchValue, refReqId) {
    if (isLoggedInRetailer()) {
        return localizedUrlWithQueryParams(productSearch({
            q: searchValue
        }), {
            refType: ISearchRequestReferrer.SearchRequestReferrerType.SUGGESTIONS_TRENDING_SEARCHES,
            refReqId: refReqId
        });
    }
    return discoverSearch(searchValue.toLowerCase());
};
var searchTrendingSearchesArray = function(searchRecommendations, sectionName, requestId) {
    return searchRecommendations === null || searchRecommendations === void 0 ? void 0 : searchRecommendations.map(function(searchValue) {
        var _searchValue_name, _searchValue_name1;
        return {
            label: (_searchValue_name = searchValue.name) !== null && _searchValue_name !== void 0 ? _searchValue_name : "",
            url: trendingSearchUrl((_searchValue_name1 = searchValue.name) !== null && _searchValue_name1 !== void 0 ? _searchValue_name1 : "", requestId),
            sectionName: sectionName,
            searchData: {
                image: searchValue.image
            },
            requestID: requestId
        };
    });
};
var entryCountFromSuggestions = function(suggestions) {
    var total = 0;
    Object.values(suggestions).forEach(function(suggestion) {
        total += suggestion.length;
    });
    return total;
};
var removeFocusOnTopSearchWhenTouchStart = function() {
    var topSearchElement = getDocumentOrThrow().getElementById("top-search");
    topSearchElement === null || topSearchElement === void 0 ? void 0 : topSearchElement.blur();
};
var shouldPerformPeteEventTracking = function(sectionHeader, strictLocalize) {
    return sectionHeader === getTrendingSearchesHeader(strictLocalize) || sectionHeader === getRecentSearchesHeader(strictLocalize) || sectionHeader === getBrandsHeader(strictLocalize) || sectionHeader === getTrendingBrandsHeader(strictLocalize) || sectionHeader === getSuggestedTermsHeader(strictLocalize) || sectionHeader === getBrandsYouMightKnowHeader(strictLocalize);
};
var getContainerName = function(sectionHeader, strictLocalize) {
    // TODO:: (kiminno) Refactor the suggestions to return the container names from BE instead.
    var DEFAULT_CONTAINER_NAME = "suggestions_default_container_name";
    var SEARCH_SUGGESTION_TRENDING_SEARCHES_CONTAINER_NAME = "SUGGESTIONS_TRENDING_SEARCHES";
    var RECENT_SEARCHES_CONTAINER_NAME = "SUGGESTIONS_RECENT_SEARCHES";
    var SEARCH_SUGGESTION_BRAND_SUGGESTIONS = "SUGGESTIONS_BRANDS";
    var SEARCH_SUGGESTION_QUERY_SUGGESTIONS = "SUGGESTIONS_SEARCH_QUERIES";
    var SEARCH_SUGGESTION_BRANDS_YOU_MAY_KNOW = "SUGGESTIONS_BRANDS_YOU_MAY_KNOW";
    switch(sectionHeader){
        case getRecentSearchesHeader(strictLocalize):
            return RECENT_SEARCHES_CONTAINER_NAME;
        case getSuggestedTermsHeader(strictLocalize):
            return SEARCH_SUGGESTION_QUERY_SUGGESTIONS;
        case getTrendingSearchesHeader(strictLocalize):
            return SEARCH_SUGGESTION_TRENDING_SEARCHES_CONTAINER_NAME;
        case getBrandsHeader(strictLocalize):
            return SEARCH_SUGGESTION_BRAND_SUGGESTIONS;
        case getTrendingBrandsHeader(strictLocalize):
            return SEARCH_SUGGESTION_BRAND_SUGGESTIONS;
        case getBrandsYouMightKnowHeader(strictLocalize):
            return SEARCH_SUGGESTION_BRANDS_YOU_MAY_KNOW;
        default:
            return DEFAULT_CONTAINER_NAME;
    }
};
var getSuggestionEventToken = function(sectionHeader, suggestion, strictLocalize) {
    switch(sectionHeader){
        case getRecentSearchesHeader(strictLocalize):
            {
                return "".concat(suggestion.label);
            }
        case getSuggestedTermsHeader(strictLocalize):
            {
                return "".concat(suggestion.searchData.query);
            }
        case getTrendingSearchesHeader(strictLocalize):
            {
                return "".concat(suggestion.label);
            }
        case getBrandsYouMightKnowHeader(strictLocalize):
        case getBrandsHeader(strictLocalize):
            {
                return "".concat(suggestion.searchData.token);
            }
        case getTrendingBrandsHeader(strictLocalize):
            {
                return "".concat(suggestion.label);
            }
        default:
            return "";
    }
};
var BrandsYouMightKnowRow = function(param) {
    var sectionHeader = param.sectionHeader, suggestionArray = param.suggestionArray, sectionIndex = param.sectionIndex, trackView = param.trackView, buildRecentSearchesImageItem = param.buildRecentSearchesImageItem, buildTrendingSearchImageItem = param.buildTrendingSearchImageItem, buildImageIconItem = param.buildImageIconItem, trackClick = param.trackClick;
    var ref = useDoActionWhenVisible(function() {
        trackView(sectionHeader, suggestionArray, sectionIndex);
    });
    return trackClick && buildImageIconItem ? /*#__PURE__*/ _jsx(StyledRow, {
        align: "center",
        tabIndex: -1,
        ref: ref,
        children: suggestionArray.map(function(suggestion, suggestionIndex) {
            return buildImageIconItem(suggestion, function() {
                return trackClick(sectionHeader, sectionIndex, suggestion, suggestionIndex, false);
            });
        })
    }) : /*#__PURE__*/ _jsx(StyledRow, {
        align: "center",
        tabIndex: -1,
        ref: ref,
        children: suggestionArray.map(function(suggestion) {
            if (buildRecentSearchesImageItem) {
                return buildRecentSearchesImageItem(suggestion);
            } else if (buildTrendingSearchImageItem) {
                return buildTrendingSearchImageItem(suggestion);
            }
            return null;
        })
    });
};
var ResultsDropdownWithoutDataFetching = observer(ResultsDropdownBase);
var AllResultWrapper = styled(Row).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-99c947e5-0"
})([
    "position:relative;height:64px;padding:22px 16px 23px 19px;"
]);
var R2MPromoText = styled.div.withConfig({
    componentId: "sc-99c947e5-1"
})([
    "text-align:center;padding:",
    " !important;&:hover{background-color:rgba(234,234,234,0.5);}"
], getSpacing("2x"));
var R2MDivider = styled.div.withConfig({
    componentId: "sc-99c947e5-2"
})([
    "padding:0 8px;"
]);
var StyledRow = styled(Row).withConfig({
    componentId: "sc-99c947e5-3"
})([
    "flex-wrap:wrap;padding:2px 10px 2px 10px;"
]);
